/**
 * Helpers de formatage (devises, jours, dates).
 */
export function fmtNumber(n, digits = 0) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return Number(n).toLocaleString("fr-FR", { maximumFractionDigits: digits });
}

export function fmtMoney(n, devise = "UM", digits = 0) {
  if (n === null || n === undefined || Number.isNaN(n)) return "—";
  return `${fmtNumber(n, digits)} ${devise}`;
}

export function fmtDays(n, digits = 1) {
  return `${fmtNumber(n, digits)} j`;
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("fr-FR", { day: "2-digit", month: "long", year: "numeric" });
  } catch { return iso; }
}

export const SECTEURS = [
  { key: "sante", label: "Santé", poids: 0.30 },
  { key: "education", label: "Éducation", poids: 0.25 },
  { key: "justice", label: "Justice", poids: 0.20 },
  { key: "infrastructure", label: "Infrastructure", poids: 0.15 },
  { key: "autres", label: "Autres", poids: 0.10 },
];
